module.exports = __webpack_public_path__ + "img/elo.e1bfaa1d.svg";